import API from '../index';

export interface PickupDate {
  date: string;
  time: { from: string; to: string }[];
}

const getPickupTimeList = async (orderId: string): Promise<PickupDate[]> => {
  const data: PickupDate[] = await API.get(`/orders/${orderId}/available-pickup-time`);
  return data;
};

export default getPickupTimeList;
